import {t} from '@/i18n'

export type Subtype = {
    name: string
    icon: string
}

export type PropertyType = {
    name: string
    icon: string
    subtypes?: Record<string, Subtype>
}

/**
 * Catálogo de tipos de propriedade. As CHAVES do mapa (`text`, `date`, ...) são o
 * que se persiste em property.type e não podem mudar; o `name` é só rótulo.
 *
 * Por isso `name` é getter e não string: traduzir no carregamento do módulo
 * congelaria o idioma no que estivesse ativo naquele instante.
 */
const types: Record<string, PropertyType> = {
    text: {
        get name() { return t('type.text') }, icon: 'mdi-alphabetical', subtypes: {
            simple: { get name() { return t('subtype.simple') }, icon: "mdi-minus" },
            markdown: { get name() { return t('subtype.markdown') }, icon: "mdi-language-markdown" },
            url: { get name() { return t('subtype.url') }, icon: "mdi-link-variant" },
        }
    },
    date: { get name() { return t('type.date') }, icon: 'mdi-calendar' },
    number: {
        get name() { return t('type.number') }, icon: 'mdi-pound', subtypes: {
            integer: { get name() { return t('subtype.integer') }, icon: 'mdi-numeric' },
            decimal: { get name() { return t('subtype.decimal') }, icon: 'mdi-decimal' }
        }
    },
    //Polegar para cima e para baixo: o campo são dois botões, Sim e Não, e não mais uma caixa de
    //marcar. O `order-bool-ascending-variant` (um ✓ e um ✗ empilhados) foi tentado e não agradou
    boolean: {
        get name() { return t('type.boolean') }, icon: 'mdi-thumbs-up-down-outline'
    },
    image: {
        get name() { return t('type.image') }, icon: 'mdi-image'
    },
    audio: {
        get name() { return t('type.audio') }, icon: 'mdi-music-note'
    },
    //Sem subtipos: o que varia entre um campo de seleção e outro é o DOMÍNIO, que é
    //entidade do ambiente e não uma variação do tipo.
    choice: {
        get name() { return t('type.choice') }, icon: 'mdi-format-list-bulleted'
    },
    //Uma pessoa do ambiente: guarda o id da conta, e mostra a cara, o nome e o e-mail de hoje
    user: {
        get name() { return t('type.user') }, icon: 'mdi-account'
    }
}

export default types
